
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequiref920"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequiref920"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("1KLms", function(module, exports) {

$parcel$export(module.exports, "SoftwareRovoStartPage", function () { return $c557b94eb5177315$export$7b3d03c2fa269586; });

var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $g9kzu = parcelRequire("g9kzu");

var $fxdfZ = parcelRequire("fxdfZ");
parcelRequire("2zn7e");
var $jnZak = parcelRequire("jnZak");

var $63FK4 = parcelRequire("63FK4");
const $c557b94eb5177315$export$7b3d03c2fa269586 = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $g9kzu.useAnalyticsEvents)();
    const handleOnError = (0, $iSvIT.useCallback)((error)=>{
        createAnalyticsEvent({
            action: "failed",
            eventType: "track",
            actionSubject: "SoftwareRovoStartPage",
            source: "SoftwareRovoStartPage",
            attributes: {
                error: error.message
            }
        }).fire();
    }, [
        createAnalyticsEvent
    ]);
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $fxdfZ.default), {
        fallback: /*#__PURE__*/ (0, $loA2J.jsx)((0, $63FK4.ErrorScreen), {}),
        onError: handleOnError,
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $jnZak.SoftwareRovoStartPageTemplate), {})
    });
};

});
parcelRegister("2zn7e", function(module, exports) {

$parcel$export(module.exports, "SoftwareRovoStartPageTemplate", function () { return (parcelRequire("jnZak")).SoftwareRovoStartPageTemplate; });

var $jnZak = parcelRequire("jnZak");

});
parcelRegister("jnZak", function(module, exports) {

$parcel$export(module.exports, "SoftwareRovoStartPageTemplate", function () { return $9e8e33cbd5ba7982$export$89c9d15d38180eeb; });

var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $g9kzu = parcelRequire("g9kzu");

var $gkhN4 = parcelRequire("gkhN4");

var $9xGVG = parcelRequire("9xGVG");

var $5wOn9 = parcelRequire("5wOn9");

var $dWbel = parcelRequire("dWbel");

var $kR0zI = parcelRequire("kR0zI");

var $50BgN = parcelRequire("50BgN");

var $20Igh = parcelRequire("20Igh");
const $9e8e33cbd5ba7982$export$89c9d15d38180eeb = ()=>{
    const stargateClient = (0, $gkhN4.useBxpWebStargateClient)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $g9kzu.useAnalyticsEvents)();
    const analyticsClient = (0, $dWbel.useAnalyticsClient)();
    const { isUserLoggedIn: isUserLoggedIn, requestInProgress: requestInProgress } = (0, $5wOn9.useLoggedInUser)();
    const [redirectUrl, setRedirectUrl] = (0, $iSvIT.useState)();
    const localizedContactHref = (0, $kR0zI.useLocalizedHref)("/enterprise/contact");
    const adminBaseUrl = (0, $iSvIT.useMemo)(()=>{
        if (typeof window === "undefined") return "https://admin.atlassian.com";
        return (0, $9xGVG.isProduction)() ? "https://admin.atlassian.com" : "https://admin.stg.atlassian.com";
    }, []);
    (0, $iSvIT.useEffect)(()=>{
        redirectUrl && setTimeout(()=>window.location.href = redirectUrl, 300);
    }, [
        redirectUrl
    ]);
    const fireViewAnalytics = (0, $iSvIT.useCallback)((attributes = {})=>{
        analyticsClient && createAnalyticsEvent({
            action: "viewed",
            eventType: "screen",
            name: "softwareRovoStartPage",
            source: "softwareRovoStartPage",
            attributes: attributes
        }).fire();
    }, [
        analyticsClient,
        createAnalyticsEvent
    ]);
    const getIsOrgAdmin = (0, $iSvIT.useCallback)(async ()=>{
        const { success: success, accountOrgs: accountOrgs } = await stargateClient.getAccountOrgs({});
        if (!success) throw new Error("Get account/orgs call failed");
        const isOrgAdmin = !!(accountOrgs && accountOrgs.length > 0);
        fireViewAnalytics({
            isOrgAdmin: isOrgAdmin
        });
        isOrgAdmin ? setRedirectUrl(`${adminBaseUrl}/rovo`) : setRedirectUrl(localizedContactHref);
    }, [
        fireViewAnalytics,
        stargateClient,
        setRedirectUrl,
        localizedContactHref,
        adminBaseUrl
    ]);
    const checkIfRovoProductExists = (0, $iSvIT.useCallback)(async ()=>{
        const productsUrl = (0, $9xGVG.isProduction)() ? "https://rovo.atlassian.com" : "https://home.stg.atlassian.com/rovo";
        const { accountProducts: accountProducts, success: success } = await stargateClient.getAccountProducts({});
        if (!success) throw new Error("Get account/products call failed");
        if (accountProducts && accountProducts.length > 0) {
            const siteWithRovo = accountProducts.find((site)=>site.products.includes("rovo.ondemand"));
            if (siteWithRovo) {
                fireViewAnalytics({
                    hasRovo: true
                });
                const cloudId = siteWithRovo.cloudId;
                setRedirectUrl(`${productsUrl}?cloudId=${cloudId}`);
                return;
            }
        }
        getIsOrgAdmin();
    }, [
        stargateClient,
        fireViewAnalytics,
        getIsOrgAdmin,
        setRedirectUrl
    ]);
    (0, $iSvIT.useEffect)(()=>{
        switch(requestInProgress){
            case false:
                switch(isUserLoggedIn){
                    case true:
                        checkIfRovoProductExists();
                        break;
                    case false:
                        fireViewAnalytics();
                        break;
                    default:
                        break;
                }
                break;
            default:
                break;
        }
    }, [
        fireViewAnalytics,
        checkIfRovoProductExists,
        isUserLoggedIn,
        requestInProgress
    ]);
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $loA2J.Fragment), {
        children: !requestInProgress && !isUserLoggedIn ? /*#__PURE__*/ (0, $loA2J.jsx)((0, $50BgN.LoginContactSales), {}) : /*#__PURE__*/ (0, $loA2J.jsx)((0, $20Igh.LoadingSpinner), {})
    });
};

});
parcelRegister("50BgN", function(module, exports) {

$parcel$export(module.exports, "LoginContactSales", function () { return $2b8bf8cf4f50a1d3$export$6a33a815ad7360e9; });
/* login-contact-sales.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $loA2J = parcelRequire("loA2J");

var $esG4f = parcelRequire("esG4f");

var $iSvIT = parcelRequire("iSvIT");

var $dFnC9 = parcelRequire("dFnC9");
var $f6qj2 = parcelRequire("f6qj2");

var $g9kzu = parcelRequire("g9kzu");

var $gf1F9 = parcelRequire("gf1F9");

var $iBKUT = parcelRequire("iBKUT");

var $257fv = parcelRequire("257fv");
var $6fxse = parcelRequire("6fxse");
var $jXVyf = parcelRequire("jXVyf");
var $agt8L = parcelRequire("agt8L");
var $j7TVc = parcelRequire("j7TVc");

var $91nJf = parcelRequire("91nJf");
parcelRequire("bGE1b");
var $1p5F6 = parcelRequire("1p5F6");

var $iu8Ap = parcelRequire("iu8Ap");

var $1UUq1 = parcelRequire("1UUq1");

var $9xGVG = parcelRequire("9xGVG");

var $dWbel = parcelRequire("dWbel");

var $kR0zI = parcelRequire("kR0zI");

var $44WDd = parcelRequire("44WDd");

var $aRRBD = parcelRequire("aRRBD");
const $2b8bf8cf4f50a1d3$var$elevatedContainerInnerStyles = (0, $j7TVc.xcss)({
    textAlign: "center",
    paddingBlockStart: "space.500"
});
const $2b8bf8cf4f50a1d3$var$bodyTextStyles = (0, $j7TVc.xcss)({
    paddingBlockStart: "space.100"
});
const $2b8bf8cf4f50a1d3$var$loginButtonStyles = (0, $j7TVc.xcss)({
    paddingBlockStart: "space.400",
    paddingBlockEnd: "space.400",
    paddingInlineStart: "space.800",
    paddingInlineEnd: "space.800"
});
const $2b8bf8cf4f50a1d3$var$contactAtlassianStyles = (0, $j7TVc.xcss)({
    justifyContent: "center"
});
const $2b8bf8cf4f50a1d3$var$relative = null;
const $2b8bf8cf4f50a1d3$var$whiteBackground = null;
const $2b8bf8cf4f50a1d3$export$6a33a815ad7360e9 = ()=>{
    const intl = (0, $f6qj2.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $g9kzu.useAnalyticsEvents)();
    const analyticsClient = (0, $dWbel.useAnalyticsClient)();
    const localizedContactHref = (0, $kR0zI.useLocalizedHref)("/enterprise/contact");
    const fireButtonAnalytics = (0, $iSvIT.useCallback)((buttonName)=>{
        analyticsClient && createAnalyticsEvent({
            action: "clicked",
            actionSubject: buttonName,
            actionSubjectId: "softwareRovoStartPageTemplate",
            attributes: {
                source: "loginContactSalesScreen"
            }
        }).fire();
    }, [
        analyticsClient,
        createAnalyticsEvent
    ]);
    const loginButtonHandler = (0, $iSvIT.useCallback)(()=>fireButtonAnalytics("loginButton"), [
        fireButtonAnalytics
    ]);
    const contactSalesLinkHandler = (0, $iSvIT.useCallback)(()=>fireButtonAnalytics("contactSalesLink"), [
        fireButtonAnalytics
    ]);
    const loginUrl = (0, $iSvIT.useMemo)(()=>{
        if (typeof window === "undefined") return "id.atlassian.com/";
        return (0, $9xGVG.isProduction)() ? "https://id.atlassian.com/" : "https://id.stg.internal.atlassian.com/";
    }, []);
    const LinktoContactAtlassian = (props)=>/*#__PURE__*/ (0, $loA2J.jsx)((0, $1UUq1.Link), {
            href: localizedContactHref,
            type: "primary",
            ariaLabel: "Contact Atlassian Page",
            "aria-label": "Contact Atlassian Page",
            text: props.children,
            onClick: contactSalesLinkHandler
        });
    const allItemsContactAtlassian = intl.formatMessage((0, $44WDd.messages).contactAtlassianText, {
        a: (contactAtlassian)=>/*#__PURE__*/ (0, $loA2J.jsx)(LinktoContactAtlassian, {
                children: contactAtlassian
            })
    });
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $iu8Ap.SignupBackgroundLayout), {
        ProductLogo: /*#__PURE__*/ (0, $loA2J.jsx)((0, $iBKUT.RovoLogo), {
            size: "xlarge",
            appearance: "brand"
        }),
        children: /*#__PURE__*/ (0, $loA2J.jsxs)((0, $jXVyf.default), {
            xcss: $2b8bf8cf4f50a1d3$var$elevatedContainerInnerStyles,
            children: [
                /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                    className: (0, $esG4f.default)([
                        "_kqswh2mm _1pbyidpf"
                    ]),
                    children: [
                        /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                            className: (0, $esG4f.default)([
                                "_kqswstnw _152tidpf _u7coidpf _1e02idpf _rjxpidpf _1bsb1osq _4t3i1osq _bfhku67f _1pby1mrw"
                            ])
                        }),
                        /*#__PURE__*/ (0, $loA2J.jsx)((0, $gf1F9.default), {
                            as: "h1",
                            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), (0, $6iHNw._)((0, $7Knp0._)({}, (0, $44WDd.messages).rovoGetStarted), {
                                values: {
                                    started: (str)=>/*#__PURE__*/ (0, $loA2J.jsx)((0, $1p5F6.Adg4TextUnderline), {
                                            underline: /*#__PURE__*/ (0, $loA2J.jsx)((0, $aRRBD.ScribbleImage), {}),
                                            fontWeight: {
                                                from: 600,
                                                to: 600
                                            },
                                            children: str
                                        })
                                }
                            }))
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $loA2J.jsx)((0, $257fv.default), {
                    xcss: $2b8bf8cf4f50a1d3$var$bodyTextStyles,
                    children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $agt8L.default), {
                        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), (0, $7Knp0._)({}, (0, $44WDd.messages).rovoBodyText))
                    })
                }),
                /*#__PURE__*/ (0, $loA2J.jsx)((0, $257fv.default), {
                    xcss: $2b8bf8cf4f50a1d3$var$loginButtonStyles,
                    children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $91nJf.Adg4Button), {
                        size: "small",
                        isFullWidth: true,
                        "aria-label": "Login Button",
                        href: `${loginUrl}login?continue=${encodeURIComponent(window.location.href)}`,
                        onClick: loginButtonHandler,
                        target: "",
                        children: intl.formatMessage((0, $44WDd.messages).loginButtonRovo)
                    })
                }),
                /*#__PURE__*/ (0, $loA2J.jsxs)((0, $6fxse.default), {
                    space: "space.100",
                    xcss: $2b8bf8cf4f50a1d3$var$contactAtlassianStyles,
                    children: [
                        /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), (0, $7Knp0._)({}, (0, $44WDd.messages).dontHaveAccountText)),
                        /*#__PURE__*/ (0, $loA2J.jsx)((0, $257fv.default), {
                            children: allItemsContactAtlassian
                        })
                    ]
                })
            ]
        })
    });
};

});
parcelRegister("gf1F9", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bd2f563b70e4a361$export$2e2bcd8739ae039; });

var $55bgW = parcelRequire("55bgW");

var $hoKRr = parcelRequire("hoKRr");

var $51AkP = parcelRequire("51AkP");

var $2ZUkg = parcelRequire("2ZUkg");

var $lKLho = parcelRequire("lKLho");

var $f0Q8n = parcelRequire("f0Q8n");

var $XAEGR = parcelRequire("XAEGR");
var $bd2f563b70e4a361$var$_excluded = [
    "level",
    "size",
    "variant"
];
// https://atlassian.design/foundations/typography
var $bd2f563b70e4a361$var$levelMap = {
    h900: "h1",
    h800: "h1",
    h700: "h2",
    h600: "h3",
    h500: "h4",
    h400: "h5",
    h300: "h6",
    // NB: These two levels are not covered at all by the existing @atlaskit/css-reset
    h200: "div",
    h100: "div"
};
var $bd2f563b70e4a361$var$headingResetStyles = (0, $2ZUkg.css)({
    color: "var(--ds-text, #172B4D)",
    marginBlock: "var(--ds-space-0, 0px)"
});
var $bd2f563b70e4a361$var$h900Styles = (0, $2ZUkg.css)({
    fontSize: "var(--ds-font-size-600, 35px)",
    fontWeight: "var(--ds-font-weight-medium, 500)",
    letterSpacing: "-0.01em",
    lineHeight: "var(--ds-font-lineHeight-600, 40px)"
});
var $bd2f563b70e4a361$var$h800Styles = (0, $2ZUkg.css)({
    fontSize: "var(--ds-font-size-500, 29px)",
    fontWeight: "var(--ds-font-weight-semibold, 600)",
    letterSpacing: "-0.01em",
    lineHeight: "var(--ds-font-lineHeight-500, 32px)"
});
var $bd2f563b70e4a361$var$h700Styles = (0, $2ZUkg.css)({
    fontSize: "var(--ds-font-size-400, 24px)",
    fontWeight: "var(--ds-font-weight-medium, 500)",
    letterSpacing: "-0.01em",
    lineHeight: "var(--ds-font-lineHeight-400, 28px)"
});
var $bd2f563b70e4a361$var$h600Styles = (0, $2ZUkg.css)({
    fontSize: "var(--ds-font-size-300, 20px)",
    fontWeight: "var(--ds-font-weight-medium, 500)",
    letterSpacing: "-0.008em",
    lineHeight: "var(--ds-font-lineHeight-300, 24px)"
});
var $bd2f563b70e4a361$var$h500Styles = (0, $2ZUkg.css)({
    fontSize: "var(--ds-font-size-200, 16px)",
    fontWeight: "var(--ds-font-weight-semibold, 600)",
    letterSpacing: "-0.006em",
    lineHeight: "var(--ds-font-lineHeight-200, 20px)"
});
var $bd2f563b70e4a361$var$h400Styles = (0, $2ZUkg.css)({
    fontSize: "var(--ds-font-size-100, 14px)",
    fontWeight: "var(--ds-font-weight-semibold, 600)",
    letterSpacing: "-0.003em",
    lineHeight: "var(--ds-font-lineHeight-100, 16px)"
});
var $bd2f563b70e4a361$var$h300Styles = (0, $2ZUkg.css)({
    fontSize: "var(--ds-font-size-075, 12px)",
    fontWeight: "var(--ds-font-weight-semibold, 600)",
    letterSpacing: 0,
    lineHeight: "var(--ds-font-lineHeight-100, 16px)",
    textTransform: "uppercase"
});
var $bd2f563b70e4a361$var$h200Styles = (0, $2ZUkg.css)({
    fontSize: "var(--ds-font-size-075, 12px)",
    fontWeight: "var(--ds-font-weight-semibold, 600)",
    letterSpacing: 0,
    lineHeight: "var(--ds-font-lineHeight-100, 16px)"
});
var $bd2f563b70e4a361$var$h100Styles = (0, $2ZUkg.css)({
    fontSize: "var(--ds-font-size-050, 11px)",
    fontWeight: "var(--ds-font-weight-bold, 700)",
    letterSpacing: 0,
    lineHeight: "var(--ds-font-lineHeight-100, 16px)"
});
var $bd2f563b70e4a361$var$inverseStyles = (0, $2ZUkg.css)({
    color: "var(--ds-text-inverse, #FFF)"
});
var $bd2f563b70e4a361$var$subtlestStyles = (0, $2ZUkg.css)({
    color: "var(--ds-text-subtlest, #6B778C)"
});
/**
 * __Heading__
 *
 * A heading is a typography component used to display text in different sizes and formats.
 *
 * @example
 *
 * ```jsx
 * import Heading from '@atlaskit/heading';
 *
 * const H100 = () => (
 *   <Heading level="h100">h100</Heading>
 * );
 * ```
 */ var $bd2f563b70e4a361$var$Heading = function Heading(_ref) {
    var children = _ref.children, level = _ref.level, id = _ref.id, testId = _ref.testId, as = _ref.as, _ref$color = _ref.color, color = _ref$color === void 0 ? "default" : _ref$color;
    typeof $XAEGR;
    var _useHeading = (0, $lKLho.useHeading)($bd2f563b70e4a361$var$levelMap[level]), _useHeading2 = (0, $51AkP.default)(_useHeading, 2), hLevel = _useHeading2[0], inferredElement = _useHeading2[1];
    var Markup = as || inferredElement;
    var isSubtleHeading = level === "h200" || level === "h100";
    var needsAriaRole = Markup === "div" && hLevel;
    return (0, $2ZUkg.jsx)(Markup, {
        id: id,
        "data-testid": testId,
        role: needsAriaRole ? "heading" : undefined,
        "aria-level": needsAriaRole ? hLevel : undefined,
        css: [
            $bd2f563b70e4a361$var$headingResetStyles,
            level === "h100" && $bd2f563b70e4a361$var$h100Styles,
            level === "h200" && $bd2f563b70e4a361$var$h200Styles,
            level === "h300" && $bd2f563b70e4a361$var$h300Styles,
            level === "h400" && $bd2f563b70e4a361$var$h400Styles,
            level === "h500" && $bd2f563b70e4a361$var$h500Styles,
            level === "h600" && $bd2f563b70e4a361$var$h600Styles,
            level === "h700" && $bd2f563b70e4a361$var$h700Styles,
            level === "h800" && $bd2f563b70e4a361$var$h800Styles,
            level === "h900" && $bd2f563b70e4a361$var$h900Styles,
            color === "inverse" && $bd2f563b70e4a361$var$inverseStyles,
            color === "default" && isSubtleHeading && $bd2f563b70e4a361$var$subtlestStyles
        ]
    }, children);
};
var $bd2f563b70e4a361$export$2e2bcd8739ae039 = function(_ref2) {
    var level = _ref2.level, size = _ref2.size, variant = _ref2.variant, props = (0, $hoKRr.default)(_ref2, $bd2f563b70e4a361$var$_excluded);
    return level ? // eslint-disable-next-line jsx-a11y/heading-has-content
    (0, $2ZUkg.jsx)($bd2f563b70e4a361$var$Heading, (0, $55bgW.default)({
        level: level
    }, props)) : // eslint-disable-next-line jsx-a11y/heading-has-content
    (0, $2ZUkg.jsx)((0, $f0Q8n.default), (0, $55bgW.default)({
        variant: variant,
        size: size
    }, props));
};

});
parcelRegister("55bgW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3b3629cfac53a12d$export$2e2bcd8739ae039; });
function $3b3629cfac53a12d$export$2e2bcd8739ae039() {
    return $3b3629cfac53a12d$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $3b3629cfac53a12d$export$2e2bcd8739ae039.apply(null, arguments);
}

});

parcelRegister("hoKRr", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $caa9072beea685d0$export$2e2bcd8739ae039; });

var $3yQ29 = parcelRequire("3yQ29");
function $caa9072beea685d0$export$2e2bcd8739ae039(e, t) {
    if (null == e) return {};
    var o, r, i = (0, $3yQ29.default)(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}

});
parcelRegister("3yQ29", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $297ce8e5514af5b7$export$2e2bcd8739ae039; });
function $297ce8e5514af5b7$export$2e2bcd8739ae039(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}

});


parcelRegister("51AkP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3a893b15f80cd459$export$2e2bcd8739ae039; });

var $55WqS = parcelRequire("55WqS");

var $9bwzO = parcelRequire("9bwzO");

var $48n3y = parcelRequire("48n3y");

var $63ytQ = parcelRequire("63ytQ");
function $3a893b15f80cd459$export$2e2bcd8739ae039(r, e) {
    return (0, $55WqS.default)(r) || (0, $9bwzO.default)(r, e) || (0, $48n3y.default)(r, e) || (0, $63ytQ.default)();
}

});
parcelRegister("55WqS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3b5abed66b4d156d$export$2e2bcd8739ae039; });
function $3b5abed66b4d156d$export$2e2bcd8739ae039(r) {
    if (Array.isArray(r)) return r;
}

});

parcelRegister("9bwzO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6afe692e4836e851$export$2e2bcd8739ae039; });
function $6afe692e4836e851$export$2e2bcd8739ae039(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}

});

parcelRegister("48n3y", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3029cb4c0a9b1fea$export$2e2bcd8739ae039; });

var $gUiIg = parcelRequire("gUiIg");
function $3029cb4c0a9b1fea$export$2e2bcd8739ae039(r, a) {
    if (r) {
        if ("string" == typeof r) return (0, $gUiIg.default)(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? (0, $gUiIg.default)(r, a) : void 0;
    }
}

});
parcelRegister("gUiIg", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c4f0644843190b98$export$2e2bcd8739ae039; });
function $c4f0644843190b98$export$2e2bcd8739ae039(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}

});


parcelRegister("63ytQ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $468dc4fb5050bd06$export$2e2bcd8739ae039; });
function $468dc4fb5050bd06$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});


parcelRegister("lKLho", function(module, exports) {

$parcel$export(module.exports, "useHeading", function () { return $fd6291971cdbcf3a$export$97a37b1befbbf9b1; });

var $iSvIT = parcelRequire("iSvIT");
// Allows support for heading levels 1-9 via aria-level
var $fd6291971cdbcf3a$var$HeadingLevelContext = /*#__PURE__*/ (0, $iSvIT.createContext)(0);
var $fd6291971cdbcf3a$export$6a64a1e2d0bbbf75 = function useHeadingLevel() {
    return (0, $iSvIT.useContext)($fd6291971cdbcf3a$var$HeadingLevelContext);
};
var $fd6291971cdbcf3a$export$97a37b1befbbf9b1 = function useHeading(fallback) {
    var hLevel = $fd6291971cdbcf3a$export$6a64a1e2d0bbbf75();
    /**
   * Order here is important, we for now apply
   * 1. inferred a11y level (this only applies if context is present)
   * 2. default final fallback
   */ return [
        hLevel,
        hLevel && (hLevel > 6 ? "div" : "h".concat(hLevel)) || fallback
    ];
};
/**
 * __Heading level provider__
 *
 * The Heading level provider injects the heading level to all `Heading` components below it in the component tree.
 *
 * @example
 * ```tsx
 * // Will correctly infer the heading level
 * <HeadingContext value={1}>
 *  <Heading>H1</Heading>
 *  <HeadingContext>
 *    <Heading>H2</Heading>
 *  </HeadingContext>
 * </HeadingContext>
 * ```
 */ var $fd6291971cdbcf3a$var$HeadingLevelContextProvider = function HeadingLevelContextProvider(_ref) {
    var children = _ref.children, value = _ref.value;
    var parentHeadingLevel = $fd6291971cdbcf3a$export$6a64a1e2d0bbbf75();
    var headingLevel = parentHeadingLevel + 1;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement($fd6291971cdbcf3a$var$HeadingLevelContext.Provider, {
        value: value || headingLevel
    }, children);
};
var $fd6291971cdbcf3a$export$2e2bcd8739ae039 = $fd6291971cdbcf3a$var$HeadingLevelContextProvider;

});

parcelRegister("f0Q8n", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $aedf4bde1316c1cf$export$2e2bcd8739ae039; });

var $51AkP = parcelRequire("51AkP");

var $2ZUkg = parcelRequire("2ZUkg");

var $lKLho = parcelRequire("lKLho");

var $XAEGR = parcelRequire("XAEGR");
var $aedf4bde1316c1cf$var$sizeTagMap = {
    xxlarge: "h1",
    xlarge: "h1",
    large: "h2",
    medium: "h3",
    small: "h4",
    xsmall: "h5",
    xxsmall: "h6"
};
var $aedf4bde1316c1cf$var$headingResetStyles = (0, $2ZUkg.css)({
    color: "var(--ds-text, #172B4D)",
    letterSpacing: "normal",
    marginBlock: 0,
    textTransform: "none"
});
var $aedf4bde1316c1cf$var$inverseStyles = (0, $2ZUkg.css)({
    color: "var(--ds-text-inverse, #FFF)"
});
/**
 * __Heading__
 *
 * Heading is a typography component used to display text in defined sizes and styles.
 *
 * @example
 *
 * ```jsx
 * <Heading size="xxlarge">Page title</Heading>
 * ```
 */ var $aedf4bde1316c1cf$var$Heading = function Heading(_ref) {
    var children = _ref.children, size = _ref.size, variant = _ref.variant, id = _ref.id, testId = _ref.testId, as = _ref.as, _ref$color = _ref.color, color = _ref$color === void 0 ? "default" : _ref$color;
    typeof $XAEGR;
    // TODO: Temporary to move variant over to size
    var localSize = variant || size;
    // Technically size can be undefined here due to how the types work.
    // Once removing the level prop this assertion can be removed since size will be a required prop.
    var _useHeading = (0, $lKLho.useHeading)($aedf4bde1316c1cf$var$sizeTagMap[localSize]), _useHeading2 = (0, $51AkP.default)(_useHeading, 2), hLevel = _useHeading2[0], inferredElement = _useHeading2[1];
    var Component = as || inferredElement;
    var needsAriaRole = Component === "div" && hLevel;
    return (0, $2ZUkg.jsx)(Component, {
        id: id,
        "data-testid": testId,
        role: needsAriaRole ? "heading" : undefined,
        "aria-level": needsAriaRole ? hLevel : undefined,
        css: [
            $aedf4bde1316c1cf$var$headingResetStyles,
            localSize && $aedf4bde1316c1cf$var$headingSizeStylesMap[localSize],
            color === "inverse" && $aedf4bde1316c1cf$var$inverseStyles
        ]
    }, children);
};
/**
 * THIS SECTION WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::057c0fe2015c2071afe3d694c5afcc0e>>
 * @codegenId typography
 * @codegenCommand yarn workspace @atlaskit/heading codegen
 */ var $aedf4bde1316c1cf$var$headingSizeStylesMap = {
    xxlarge: (0, $2ZUkg.css)({
        font: 'var(--ds-font-heading-xxlarge, normal 500 35px/40px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)'
    }),
    xlarge: (0, $2ZUkg.css)({
        font: 'var(--ds-font-heading-xlarge, normal 600 29px/32px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)'
    }),
    large: (0, $2ZUkg.css)({
        font: 'var(--ds-font-heading-large, normal 500 24px/28px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)'
    }),
    medium: (0, $2ZUkg.css)({
        font: 'var(--ds-font-heading-medium, normal 500 20px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)'
    }),
    small: (0, $2ZUkg.css)({
        font: 'var(--ds-font-heading-small, normal 600 16px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)'
    }),
    xsmall: (0, $2ZUkg.css)({
        font: 'var(--ds-font-heading-xsmall, normal 600 14px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)'
    }),
    xxsmall: (0, $2ZUkg.css)({
        font: 'var(--ds-font-heading-xxsmall, normal 600 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)'
    })
};
var /**
 * @codegenEnd
 */ $aedf4bde1316c1cf$export$2e2bcd8739ae039 = $aedf4bde1316c1cf$var$Heading;

});


parcelRegister("iBKUT", function(module, exports) {

$parcel$export(module.exports, "RovoLogo", function () { return $d8c013606d123125$export$a0f6cb8061290bbb; });
/* eslint-disable max-len */ 
var $iSvIT = parcelRequire("iSvIT");

var $dQweN = parcelRequire("dQweN");

var $hFZoE = parcelRequire("hFZoE");

var $bLwq0 = parcelRequire("bLwq0");

var $eJjXw = parcelRequire("eJjXw");
var $d8c013606d123125$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor, textColor = _ref.textColor;
    var colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $bLwq0.getColorsFromAppearance)(appearance, colorMode);
    return '<svg fill="none" height="32" viewBox="0 0 100 32" focusable="false" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">\n      <path\n        d="M12.393 4.246a2.79 2.79 0 0 0-2.735-.026.4.4 0 0 1-.05.033l-.001.001c-.606.35-1.048.91-1.257 1.558q-.129.404-.13.842v3.675l4.603 2.656a3.64 3.64 0 0 1 1.824 3.155v9.487a3.6 3.6 0 0 1-.214 1.23l6.175-3.566A2.77 2.77 0 0 0 22 20.884v-9.487c0-.991-.532-1.912-1.392-2.408z"\n        fill="'.concat(colors.iconColor, '"\n        fillRule="evenodd"\n      />\n      <path\n        d="m1.391 9 6.176-3.566a3.6 3.6 0 0 0-.214 1.23v9.486c0 1.303.693 2.505 1.823 3.155h.001l4.603 2.657v3.674c0 .29-.045.575-.13.843a2.8 2.8 0 0 1-1.258 1.558.4.4 0 0 0-.05.033c-.85.47-1.89.461-2.734-.026l-8.216-4.743A2.78 2.78 0 0 1 0 20.893v-9.486c0-.996.529-1.912 1.391-2.408z"\n        fill="').concat(colors.iconColor, '"\n        fillRule="evenodd"\n      />\n      <path\n        d="M91.688 25.848c-4.6 0-7.298-3.404-7.298-8.004S87.088 9.9 91.688 9.9c4.57 0 7.238 3.342 7.238 7.942s-2.668 8.004-7.238 8.004zm0-13.494c-3.28 0-4.722 2.576-4.722 5.49 0 2.913 1.441 5.55 4.722 5.55 3.251 0 4.662-2.637 4.662-5.55 0-2.914-1.41-5.49-4.662-5.49M77.675 25.54H74.15L68.2 10.208h2.76l4.968 13.094 4.938-13.095h2.76zm-17.462.308c-4.6 0-7.299-3.404-7.299-8.004s2.7-7.943 7.3-7.943c4.568 0 7.236 3.342 7.236 7.942s-2.668 8.004-7.237 8.004zm0-13.494c-3.281 0-4.723 2.576-4.723 5.49 0 2.913 1.442 5.55 4.723 5.55 3.25 0 4.661-2.637 4.661-5.55 0-2.914-1.41-5.49-4.66-5.49zM43.177 8.03H39.13v7.36h4.048c3.588 0 4.692-1.38 4.692-3.68 0-2.177-1.134-3.68-4.692-3.68zm7.452 3.619c0 3.036-1.288 5.09-3.956 5.949l4.938 7.943H48.36l-4.447-7.514H39.13v7.514h-2.76V5.393h7.115c4.815 0 7.145 2.392 7.145 6.256z"\n        fill="').concat(colors.textColor, '"\n      />\n    </svg>');
};
var $d8c013606d123125$export$a0f6cb8061290bbb = function RovoLogo(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? "Rovo" : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $hFZoE.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $hFZoE.defaultLogoParams).textColor : _ref2$textColor, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $hFZoE.defaultLogoParams).iconColor : _ref2$iconColor;
    var _useThemeObserver = (0, $dQweN.default)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $eJjXw.default), {
        appearance: appearance,
        iconColor: iconColor,
        label: label,
        size: size,
        svg: $d8c013606d123125$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("6fxse", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $48ce182491db562e$export$2e2bcd8739ae039; });

var $dClj0 = parcelRequire("dClj0");

var $iSvIT = parcelRequire("iSvIT");

var $2ZUkg = parcelRequire("2ZUkg");

var $j7TVc = parcelRequire("j7TVc");

var $1Lr0O = parcelRequire("1Lr0O");
var $48ce182491db562e$var$flexGrowMap = {
    hug: (0, $j7TVc.xcss)({
        flexGrow: 0
    }),
    fill: (0, $j7TVc.xcss)({
        width: "100%",
        flexGrow: 1
    })
};
var $48ce182491db562e$var$separatorStyles = (0, $2ZUkg.css)({
    color: "var(--ds-text-subtle, #42526E)",
    marginBlock: "var(--ds-space-0, 0px)",
    marginInline: "var(--ds-space-negative-025, -2px)",
    pointerEvents: "none",
    userSelect: "none"
});
var $48ce182491db562e$var$Separator = function Separator(_ref) {
    var children = _ref.children;
    return (0, $2ZUkg.jsx)("span", {
        css: $48ce182491db562e$var$separatorStyles
    }, children);
};
/**
 * __Inline__
 *
 * Inline is a primitive component based on CSS Flexbox that manages the horizontal layout of direct children.
 *
 * @example
 * ```tsx
 *  <Inline>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *  </Inline>
 * ```
 *
 */ var $48ce182491db562e$var$Inline = /*#__PURE__*/ (0, $iSvIT.memo)(/*#__PURE__*/ (0, $iSvIT.forwardRef)(function(_ref2, ref) {
    var as = _ref2.as, alignInline = _ref2.alignInline, _ref2$alignBlock = _ref2.alignBlock, alignItems = _ref2$alignBlock === void 0 ? "start" : _ref2$alignBlock, _ref2$shouldWrap = _ref2.shouldWrap, shouldWrap = _ref2$shouldWrap === void 0 ? false : _ref2$shouldWrap, spread = _ref2.spread, grow = _ref2.grow, space = _ref2.space, rowSpace = _ref2.rowSpace, separator = _ref2.separator, xcss = _ref2.xcss, testId = _ref2.testId, role = _ref2.role, rawChildren = _ref2.children;
    var separatorComponent = typeof separator === "string" ? (0, $2ZUkg.jsx)($48ce182491db562e$var$Separator, null, separator) : separator;
    var children = separatorComponent ? (0, $iSvIT.Children).toArray(rawChildren).filter(Boolean).map(function(child, index) {
        return (0, $2ZUkg.jsx)((0, $iSvIT.Fragment), {
            key: index
        }, separator && index > 0 ? separatorComponent : null, child);
    }) : rawChildren;
    var justifyContent = spread || alignInline;
    return (0, $2ZUkg.jsx)((0, $1Lr0O.default), {
        as: as,
        role: role,
        alignItems: alignItems,
        justifyContent: justifyContent,
        direction: "row",
        gap: space,
        rowGap: rowSpace,
        wrap: shouldWrap ? "wrap" : undefined,
        xcss: grow ? [
            $48ce182491db562e$var$flexGrowMap[grow]
        ].concat((0, $dClj0.default)(Array.isArray(xcss) ? xcss : [
            xcss
        ])) : // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
        xcss,
        testId: testId,
        ref: ref
    }, children);
}));
$48ce182491db562e$var$Inline.displayName = "Inline";
var $48ce182491db562e$export$2e2bcd8739ae039 = $48ce182491db562e$var$Inline;

});
parcelRegister("dClj0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9e9f59d4154a0a0e$export$2e2bcd8739ae039; });

var $kyY5k = parcelRequire("kyY5k");

var $cMl8z = parcelRequire("cMl8z");

var $hslXA = parcelRequire("hslXA");

var $6zNvR = parcelRequire("6zNvR");
function $9e9f59d4154a0a0e$export$2e2bcd8739ae039(r) {
    return (0, $kyY5k.default)(r) || (0, $cMl8z.default)(r) || (0, $hslXA.default)(r) || (0, $6zNvR.default)();
}

});
parcelRegister("kyY5k", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ef85973da19107e1$export$2e2bcd8739ae039; });

var $7wX0I = parcelRequire("7wX0I");
function $ef85973da19107e1$export$2e2bcd8739ae039(r) {
    if (Array.isArray(r)) return (0, $7wX0I.default)(r);
}

});

parcelRegister("cMl8z", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $94da5d202af3ce6b$export$2e2bcd8739ae039; });
function $94da5d202af3ce6b$export$2e2bcd8739ae039(r) {
    if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}

});

parcelRegister("6zNvR", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4c9c6b2b5d8fcd04$export$2e2bcd8739ae039; });
function $4c9c6b2b5d8fcd04$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});


parcelRegister("1Lr0O", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $148f22484ac02ea1$export$2e2bcd8739ae039; });
/** @jsx jsx */ 
var $iSvIT = parcelRequire("iSvIT");

var $2ZUkg = parcelRequire("2ZUkg");

var $ihHOk = parcelRequire("ihHOk");

var $j7TVc = parcelRequire("j7TVc");
var $148f22484ac02ea1$var$justifyContentMap = {
    start: (0, $2ZUkg.css)({
        justifyContent: "start"
    }),
    center: (0, $2ZUkg.css)({
        justifyContent: "center"
    }),
    end: (0, $2ZUkg.css)({
        justifyContent: "end"
    }),
    "space-between": (0, $2ZUkg.css)({
        justifyContent: "space-between"
    }),
    "space-around": (0, $2ZUkg.css)({
        justifyContent: "space-around"
    }),
    "space-evenly": (0, $2ZUkg.css)({
        justifyContent: "space-evenly"
    }),
    stretch: (0, $2ZUkg.css)({
        justifyContent: "stretch"
    })
};
var $148f22484ac02ea1$var$flexDirectionMap = {
    column: (0, $2ZUkg.css)({
        flexDirection: "column"
    }),
    row: (0, $2ZUkg.css)({
        flexDirection: "row"
    })
};
var $148f22484ac02ea1$var$flexWrapMap = {
    wrap: (0, $2ZUkg.css)({
        flexWrap: "wrap"
    }),
    nowrap: (0, $2ZUkg.css)({
        flexWrap: "nowrap"
    })
};
var $148f22484ac02ea1$var$alignItemsMap = {
    start: (0, $2ZUkg.css)({
        alignItems: "start"
    }),
    center: (0, $2ZUkg.css)({
        alignItems: "center"
    }),
    baseline: (0, $2ZUkg.css)({
        alignItems: "baseline"
    }),
    end: (0, $2ZUkg.css)({
        alignItems: "end"
    }),
    stretch: (0, $2ZUkg.css)({
        alignItems: "stretch"
    })
};
var $148f22484ac02ea1$var$baseStyles = (0, $2ZUkg.css)({
    display: "flex",
    boxSizing: "border-box"
});
/**
 * __Flex__
 *
 * `Flex` is a primitive component that implements the CSS Flexbox API.
 *
 * - [Examples](https://atlassian.design/components/primitives/flex/examples)
 * - [Code](https://atlassian.design/components/primitives/flex/code)
 *
 * @example
 * ```tsx
 * import { Flex, Box } from '@atlaskit/primitives'
 *
 * const Component = () => (
 *   <Flex direction="column">
 *     <Box padding="space.100" backgroundColor="neutral"></Box>
 *     <Box padding="space.100" backgroundColor="neutral"></Box>
 *   </Flex>
 * )
 * ```
 */ var $148f22484ac02ea1$var$Flex = /*#__PURE__*/ (0, $iSvIT.memo)(/*#__PURE__*/ (0, $iSvIT.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? "div" : _ref$as, role = _ref.role, alignItems = _ref.alignItems, justifyContent = _ref.justifyContent, gap = _ref.gap, columnGap = _ref.columnGap, rowGap = _ref.rowGap, children = _ref.children, testId = _ref.testId, direction = _ref.direction, wrap = _ref.wrap, xcss = _ref.xcss;
    var xcssClassName = xcss && (0, $j7TVc.parseXcss)(xcss);
    return (0, $2ZUkg.jsx)(Component, {
        role: role,
        css: [
            $148f22484ac02ea1$var$baseStyles,
            gap && (0, $ihHOk.spaceStylesMap).gap[gap],
            columnGap && (0, $ihHOk.spaceStylesMap).columnGap[columnGap],
            rowGap && (0, $ihHOk.spaceStylesMap).rowGap[rowGap],
            alignItems && $148f22484ac02ea1$var$alignItemsMap[alignItems],
            direction && $148f22484ac02ea1$var$flexDirectionMap[direction],
            justifyContent && $148f22484ac02ea1$var$justifyContentMap[justifyContent],
            wrap && $148f22484ac02ea1$var$flexWrapMap[wrap],
            // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
            xcssClassName && xcssClassName
        ],
        "data-testid": testId,
        ref: ref
    }, children);
}));
$148f22484ac02ea1$var$Flex.displayName = "Flex";
var $148f22484ac02ea1$export$2e2bcd8739ae039 = $148f22484ac02ea1$var$Flex;

});


parcelRegister("jXVyf", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e8902b86efcd71d6$export$2e2bcd8739ae039; });

var $dClj0 = parcelRequire("dClj0");

var $iSvIT = parcelRequire("iSvIT");

var $2ZUkg = parcelRequire("2ZUkg");

var $j7TVc = parcelRequire("j7TVc");

var $1Lr0O = parcelRequire("1Lr0O");
var $e8902b86efcd71d6$var$flexGrowMap = {
    hug: (0, $j7TVc.xcss)({
        flexGrow: 0
    }),
    fill: (0, $j7TVc.xcss)({
        width: "100%",
        flexGrow: 1
    })
};
/**
 * __Stack__
 *
 * Stack is a primitive component based on flexbox that manages the block layout of direct children.
 *
 * @example
 * ```tsx
 *  <Stack>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *  </Stack>
 * ```
 *
 */ var $e8902b86efcd71d6$var$Stack = /*#__PURE__*/ (0, $iSvIT.memo)(/*#__PURE__*/ (0, $iSvIT.forwardRef)(function(_ref, ref) {
    var as = _ref.as, alignItems = _ref.alignInline, _ref$alignBlock = _ref.alignBlock, alignBlock = _ref$alignBlock === void 0 ? "stretch" : _ref$alignBlock, spread = _ref.spread, grow = _ref.grow, space = _ref.space, children = _ref.children, testId = _ref.testId, xcss = _ref.xcss, role = _ref.role;
    var justifyContent = spread || alignBlock;
    return (0, $2ZUkg.jsx)((0, $1Lr0O.default), {
        as: as,
        role: role,
        gap: space,
        direction: "column",
        alignItems: alignItems,
        justifyContent: justifyContent,
        xcss: grow ? [
            $e8902b86efcd71d6$var$flexGrowMap[grow]
        ].concat((0, $dClj0.default)(Array.isArray(xcss) ? xcss : [
            xcss
        ])) : // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
        xcss,
        testId: testId,
        ref: ref
    }, children);
}));
$e8902b86efcd71d6$var$Stack.displayName = "Stack";
var $e8902b86efcd71d6$export$2e2bcd8739ae039 = $e8902b86efcd71d6$var$Stack;

});

parcelRegister("agt8L", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $779200a93ff14d0d$export$2e2bcd8739ae039; });

var $eWYnH = parcelRequire("eWYnH");

var $dFcgv = parcelRequire("dFcgv");

var $iSvIT = parcelRequire("iSvIT");

var $2ZUkg = parcelRequire("2ZUkg");

var $jNYFj = parcelRequire("jNYFj");

var $ihHOk = parcelRequire("ihHOk");

var $ahkBr = parcelRequire("ahkBr");
var $779200a93ff14d0d$var$_excluded = [
    "children"
];
function $779200a93ff14d0d$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $779200a93ff14d0d$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $779200a93ff14d0d$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $dFcgv.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $779200a93ff14d0d$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $779200a93ff14d0d$var$asAllowlist = [
    "span",
    "p",
    "strong",
    "em"
];
// We're doing this because our CSS reset can add top margins to elements such as `p` which is totally insane.
// Long term we should remove those instances from the reset - it should be a reset to 0.
// For now, at least we know <Text> will be unaffected by this.
var $779200a93ff14d0d$var$resetStyles = (0, $2ZUkg.css)({
    margin: 0
});
var $779200a93ff14d0d$var$variantStyles = $779200a93ff14d0d$var$_objectSpread($779200a93ff14d0d$var$_objectSpread({}, (0, $ihHOk.bodyTextStylesMap)), (0, $ihHOk.uiTextStylesMap));
var $779200a93ff14d0d$var$strongStyles = (0, $2ZUkg.css)({
    fontWeight: "bold"
});
var $779200a93ff14d0d$var$emStyles = (0, $2ZUkg.css)({
    fontStyle: "italic"
});
var $779200a93ff14d0d$var$textAlignMap = {
    center: (0, $2ZUkg.css)({
        textAlign: "center"
    }),
    end: (0, $2ZUkg.css)({
        textAlign: "end"
    }),
    start: (0, $2ZUkg.css)({
        textAlign: "start"
    })
};
var $779200a93ff14d0d$var$truncationStyles = (0, $2ZUkg.css)({
    display: "-webkit-box",
    overflow: "hidden",
    WebkitBoxOrient: "vertical"
});
var $779200a93ff14d0d$var$wordBreakMap = {
    breakAll: (0, $2ZUkg.css)({
        wordBreak: "break-all"
    })
};
/**
 * Custom hook designed to abstract the parsing of the color props and make it clearer in the future how color is reconciled between themes and tokens.
 */ var $779200a93ff14d0d$var$useColor = function useColor(colorProp) {
    var surface = (0, $ahkBr.useSurface)();
    var inverseTextColor = (0, $ihHOk.inverseColorMap)[surface];
    /**
   * Where the color of the surface is inverted we override the user choice
   * as there is no valid choice that is not covered by the override.
   */ var color = inverseTextColor !== null && inverseTextColor !== void 0 ? inverseTextColor : colorProp;
    return color;
};
var $779200a93ff14d0d$var$HasTextAncestorContext = /*#__PURE__*/ (0, $iSvIT.createContext)(false);
var $779200a93ff14d0d$var$useHasTextAncestor = function useHasTextAncestor() {
    return (0, $iSvIT.useContext)($779200a93ff14d0d$var$HasTextAncestorContext);
};
/**
 * __Text__
 *
 * Text is a primitive component that has the Atlassian Design System's design guidelines baked in.
 * This includes considerations for text attributes such as color, font size, font weight, and line height.
 * It renders a `span` by default.
 *
 * @internal
 */ var $779200a93ff14d0d$var$Text = function Text(_ref) {
    var children = _ref.children, props = (0, $eWYnH.default)(_ref, $779200a93ff14d0d$var$_excluded);
    var asElement = props.as, _props$color = props.color, colorProp = _props$color === void 0 ? "color.text" : _props$color, textAlign = props.textAlign, testId = props.testId, id = props.id, _props$variant = props.variant, variant = _props$variant === void 0 ? "body" : _props$variant, weight = props.weight;
    // body variants -> p
    // ui variants -> span
    var Component = asElement || (variant.includes("body") ? "p" : "span");
    (0, $jNYFj.default)($779200a93ff14d0d$var$asAllowlist.includes(Component), '@atlaskit/primitives: Text received an invalid "as" value of "'.concat(Component, '"'));
    // Remove the ability to bypass typescript errors for maxLines
    var maxLines;
    if ("maxLines" in props && variant.includes("body")) maxLines = props.maxLines;
    var color = $779200a93ff14d0d$var$useColor(colorProp);
    var isWrapped = $779200a93ff14d0d$var$useHasTextAncestor();
    /**
   * If the text is already wrapped and applies no props we can just
   * render the children directly as a fragment.
   */ if (isWrapped && Object.keys(props).length === 0) return (0, $2ZUkg.jsx)((0, $iSvIT.Fragment), null, children);
    var component = (0, $2ZUkg.jsx)(Component, {
        css: [
            $779200a93ff14d0d$var$resetStyles,
            variant && $779200a93ff14d0d$var$variantStyles[variant],
            color && (0, $ihHOk.textColorStylesMap)[color],
            maxLines && $779200a93ff14d0d$var$truncationStyles,
            maxLines === 1 && $779200a93ff14d0d$var$wordBreakMap.breakAll,
            textAlign && $779200a93ff14d0d$var$textAlignMap[textAlign],
            weight && (0, $ihHOk.fontWeightStylesMap)[weight],
            asElement === "em" && $779200a93ff14d0d$var$emStyles,
            asElement === "strong" && $779200a93ff14d0d$var$strongStyles
        ],
        style: {
            WebkitLineClamp: maxLines
        },
        "data-testid": testId,
        id: id
    }, children);
    return isWrapped ? // no need to re-apply context if the text is already wrapped
    component : (0, $2ZUkg.jsx)($779200a93ff14d0d$var$HasTextAncestorContext.Provider, {
        value: true
    }, component);
};
var $779200a93ff14d0d$export$2e2bcd8739ae039 = $779200a93ff14d0d$var$Text;

});

parcelRegister("bGE1b", function(module, exports) {
$parcel$export(module.exports, "Adg4TextUnderline", function () { return (parcelRequire("1p5F6")).Adg4TextUnderline; });
parcelRequire("1p5F6");

});
parcelRegister("1p5F6", function(module, exports) {

$parcel$export(module.exports, "Adg4TextUnderline", function () { return $23a59b9be0d723ab$export$a8ef4069b9c5e8b7; });
/* text-underline.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");

var $eDoPe = parcelRequire("eDoPe");
const $23a59b9be0d723ab$var$textStyle = null;
const $23a59b9be0d723ab$var$inViewTextStyle = null;
const $23a59b9be0d723ab$var$underlineStyle = null;
const $23a59b9be0d723ab$var$inViewUnderlineStyle = null;
const $23a59b9be0d723ab$var$hiddenText = null;
const $23a59b9be0d723ab$var$visibleText = null;
const $23a59b9be0d723ab$export$a8ef4069b9c5e8b7 = ({ text: text, children: children, underline: underline, underlineInset: underlineInset = "-37.5%", underlineLeft: underlineLeft = false, fontWeight: fontWeight = {
    from: 400,
    to: 800
}, useInViewOptions: useInViewOptions })=>{
    const { ref: scrollRef, inView: sectionIsVisible } = (0, $eDoPe.useInView)(useInViewOptions);
    const fontWeightAnimation = null;
    const underlineInsetStyle = null;
    const toFontWeight = null;
    return /*#__PURE__*/ (0, $loA2J.jsxs)("span", {
        ref: scrollRef,
        className: (0, $esG4f.default)([
            "_1e0c116y _19pkidpf _2hwxidpf _otyridpf _18u0idpf _kqswh2mm _ju251bs3 _5sagfnf5 _tip8kb7n _1o51q7pw _vwz4kb7n _1nmz1hna",
            sectionIsVisible && "_j7hq1dkr"
        ]),
        style: {
            "--_15xzfe0": (0, $43MIc.default)(fontWeight.from),
            "--_1bgzcf7": (0, $43MIc.default)(fontWeight.to)
        },
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("span", {
                "aria-hidden": true,
                className: (0, $esG4f.default)([
                    "_3um015vq _lcxvglyw",
                    "_k48p103h"
                ]),
                style: {
                    "--_1bgzcf7": (0, $43MIc.default)(fontWeight.to)
                },
                children: text !== null && text !== void 0 ? text : children
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("span", {
                className: (0, $esG4f.default)([
                    "_kqswstnw _1e02idpf"
                ]),
                children: text !== null && text !== void 0 ? text : children
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                className: (0, $esG4f.default)([
                    "_1e0c1txw _1bsb1osq _mkrz16t8 _ju251bs3 _5sagpwmj _tip8kb7n _1e02idpf _1o51q7pw _kqswstnw _1pby1mrw",
                    "_u7co11y5 _cjf710zq _1kni10zq",
                    sectionIsVisible && "_j7hqzu28"
                ]),
                style: {
                    "--_1jmpxqi": (0, $43MIc.default)(underlineInset),
                    "--_p0j3r4": (0, $43MIc.default)(underlineLeft ? "0" : "auto")
                },
                children: underline
            })
        ]
    });
};

});


parcelRegister("44WDd", function(module, exports) {

$parcel$export(module.exports, "messages", function () { return $749e1e7a17e5468d$export$defe85febe8b728c; });

var $6x1qA = parcelRequire("6x1qA");
const $749e1e7a17e5468d$export$defe85febe8b728c = (0, $6x1qA.defineMessages)({
    loading: {
        id: "SoftwareRovoStart.Page.loading",
        defaultMessage: "Loading"
    },
    login: {
        id: "SoftwareRovoStart.Page.login",
        defaultMessage: "Login"
    },
    contactSales: {
        id: "SoftwareRovoStart.Page.contactSales",
        defaultMessage: "Contact Sales"
    },
    rovoGetStarted: {
        defaultMessage: "Get <started>started</started> with Rovo",
        description: "Title text for WAC Rovo Start_logged out page",
        id: "SoftwareRovoStart.Page.rovoGetStarted"
    },
    loginButtonRovo: {
        defaultMessage: "Log in",
        id: "SoftwareRovoStart.Page.loginButtonRovo"
    },
    rovoBodyText: {
        defaultMessage: "Log in to add it to your organization",
        id: "SoftwareRovoStart.Page.rovoBodyText"
    },
    dontHaveAccountText: {
        defaultMessage: "Don\u2019t have an account?",
        id: "SoftwareRovoStart.Page.dontHaveAccountText"
    },
    contactAtlassianText: {
        defaultMessage: "<a>Contact Atlassian</a>",
        id: "SoftwareRovoStart.Page.contactAtlassianText"
    },
    errorScreenTitle: {
        defaultMessage: "Something went wrong",
        description: "Error screen title",
        id: "SoftwareRovoStart.Page.errorScreenTitle"
    },
    errorScreenMessageOne: {
        defaultMessage: "<a>Contact support</a> for further help or try again.",
        description: "Error screen message part one",
        id: "SoftwareRovoStart.Page.errorScreenMessageOne"
    },
    errorScreenMessageTwo: {
        defaultMessage: "To receive a quote for Rovo, <a>contact sales.</a>",
        description: "Error screen message part two",
        id: "SoftwareRovoStart.Page.errorScreenMessageTwo"
    }
});

});

parcelRegister("aRRBD", function(module, exports) {

$parcel$export(module.exports, "ScribbleImage", function () { return $891ddbb87e58b62a$export$31b1a25c5f295125; });

var $loA2J = parcelRequire("loA2J");
const $891ddbb87e58b62a$var$ScribbleImageComponent = ()=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)("svg", {
        width: "105",
        height: "17",
        viewBox: "0 0 105 17",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, $loA2J.jsx)("path", {
            d: "M104.435 9.68613C86.4938 6.51631 73.1262 13.83 55.0489 7.43996C54.1658 10.0608 51.9298 13.3276 48.6487 13.3318C51.3855 13.3082 55.8543 6.49074 51.3954 11.0379C48.7638 14.5108 37.5257 10.0724 46.1409 13.2376C40.1743 12.5113 34.7527 8.16936 30.7652 4.31768C24.1184 -1.18196 29.0775 9.35501 24.148 14.5541C17.1646 21.7785 -3.47552 2.46837 0.735557 2.51293C3.38441 4.93365 6.96197 6.46719 8.41505 9.13148C34.4142 25.1383 15.8926 -4.08831 31.4374 0.975475C56.6666 21.4402 44.0238 3.05288 58.9761 4.49783C67.6031 11.908 104.856 0.972575 104.442 9.68622L104.435 9.68613Z",
            fill: "#FCA700"
        })
    });
};
const $891ddbb87e58b62a$export$31b1a25c5f295125 = $891ddbb87e58b62a$var$ScribbleImageComponent;

});


parcelRegister("20Igh", function(module, exports) {

$parcel$export(module.exports, "LoadingSpinner", function () { return $236206e4ad5a6732$export$b08b517936747730; });
/* spinner.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $f6qj2 = parcelRequire("f6qj2");

var $9gh2a = parcelRequire("9gh2a");

var $44WDd = parcelRequire("44WDd");
const $236206e4ad5a6732$var$loadingCss = null;
const $236206e4ad5a6732$export$b08b517936747730 = ()=>{
    const intl = (0, $f6qj2.default)();
    return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
        role: "progressbar",
        "aria-label": intl.formatMessage((0, $44WDd.messages).loading),
        className: (0, $esG4f.default)([
            "_4cvr1h6o _1e0c1txw _1bah1h6o _1tke1kxc"
        ]),
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $9gh2a.default), {
            size: "large"
        })
    });
};

});



parcelRegister("63FK4", function(module, exports) {

$parcel$export(module.exports, "ErrorScreen", function () { return $9a973e4f77d5475a$export$42f84e610f279c31; });
/* error-screen.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $dFnC9 = parcelRequire("dFnC9");

var $g9kzu = parcelRequire("g9kzu");

var $gf1F9 = parcelRequire("gf1F9");

var $iBKUT = parcelRequire("iBKUT");

var $6fxse = parcelRequire("6fxse");
var $jXVyf = parcelRequire("jXVyf");
var $j7TVc = parcelRequire("j7TVc");

var $iu8Ap = parcelRequire("iu8Ap");

var $dWbel = parcelRequire("dWbel");

var $kR0zI = parcelRequire("kR0zI");

var $44WDd = parcelRequire("44WDd");

var $6unIx = parcelRequire("6unIx");
const $9a973e4f77d5475a$var$elevatedContainerInnerStyles = (0, $j7TVc.xcss)({
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: "space.400",
    alignSelf: "stretch",
    paddingBlockStart: "space.150"
});
const $9a973e4f77d5475a$var$contentStyles = (0, $j7TVc.xcss)({
    display: "inline-flex",
    flexDirection: "column",
    alignItems: "center",
    gap: "space.200"
});
const $9a973e4f77d5475a$var$bodyStyles = (0, $j7TVc.xcss)({
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    alignSelf: "stretch",
    fontSize: 'var(--ds-font-heading-small, normal 600 16px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif)',
    fontWeight: "400"
});
const $9a973e4f77d5475a$var$linkStyles = null;
const $9a973e4f77d5475a$export$42f84e610f279c31 = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $g9kzu.useAnalyticsEvents)();
    const analyticsClient = (0, $dWbel.useAnalyticsClient)();
    const localizedContactHref = (0, $kR0zI.useLocalizedHref)("/enterprise/contact");
    (0, $iSvIT.useEffect)(()=>{
        analyticsClient && createAnalyticsEvent({
            action: "viewed",
            eventType: "screen",
            name: "softwareRovoStartPageErrorScreen",
            source: "softwareRovoStartPage"
        }).fire();
    }, [
        analyticsClient,
        createAnalyticsEvent
    ]);
    const fireButtonAnalytics = (0, $iSvIT.useCallback)((buttonName)=>{
        analyticsClient && createAnalyticsEvent({
            action: "clicked",
            actionSubject: buttonName,
            actionSubjectId: "softwareRovoStartPageTemplate",
            attributes: {
                source: "errorScreen"
            }
        }).fire();
    }, [
        analyticsClient,
        createAnalyticsEvent
    ]);
    const contactSupportLinkHandler = (0, $iSvIT.useCallback)(()=>fireButtonAnalytics("contactSupportLink"), [
        fireButtonAnalytics
    ]);
    const contactSalesLinkHandler = (0, $iSvIT.useCallback)(()=>fireButtonAnalytics("contactSalesLink"), [
        fireButtonAnalytics
    ]);
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $iu8Ap.SignupBackgroundLayout), {
        ProductLogo: /*#__PURE__*/ (0, $loA2J.jsx)((0, $iBKUT.RovoLogo), {
            size: "xlarge",
            appearance: "brand"
        }),
        children: /*#__PURE__*/ (0, $loA2J.jsxs)((0, $jXVyf.default), {
            xcss: $9a973e4f77d5475a$var$elevatedContainerInnerStyles,
            children: [
                /*#__PURE__*/ (0, $loA2J.jsx)((0, $6unIx.ErrorIconImage), {}),
                /*#__PURE__*/ (0, $loA2J.jsxs)((0, $jXVyf.default), {
                    xcss: $9a973e4f77d5475a$var$contentStyles,
                    children: [
                        /*#__PURE__*/ (0, $loA2J.jsx)((0, $gf1F9.default), {
                            as: "h1",
                            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), (0, $7Knp0._)({}, (0, $44WDd.messages).errorScreenTitle))
                        }),
                        /*#__PURE__*/ (0, $loA2J.jsxs)((0, $jXVyf.default), {
                            xcss: $9a973e4f77d5475a$var$bodyStyles,
                            children: [
                                /*#__PURE__*/ (0, $loA2J.jsx)((0, $6fxse.default), {
                                    space: "space.075",
                                    children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), (0, $6iHNw._)((0, $7Knp0._)({}, (0, $44WDd.messages).errorScreenMessageOne), {
                                        values: {
                                            a: (text)=>/*#__PURE__*/ (0, $loA2J.jsx)("a", {
                                                    href: "https://support.atlassian.com/contact/",
                                                    onClick: contactSupportLinkHandler,
                                                    "aria-label": "Contact Atlassian Support Page",
                                                    className: (0, $esG4f.default)([
                                                        "_y3gn1h6o _syaz14q2 _k48p1fw0"
                                                    ]),
                                                    children: text
                                                })
                                        }
                                    }))
                                }),
                                /*#__PURE__*/ (0, $loA2J.jsx)((0, $6fxse.default), {
                                    space: "space.075",
                                    children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), (0, $6iHNw._)((0, $7Knp0._)({}, (0, $44WDd.messages).errorScreenMessageTwo), {
                                        values: {
                                            a: (text)=>/*#__PURE__*/ (0, $loA2J.jsx)("a", {
                                                    href: localizedContactHref,
                                                    onClick: contactSalesLinkHandler,
                                                    "aria-label": "Contact Atlassian Sales Page",
                                                    className: (0, $esG4f.default)([
                                                        "_y3gn1h6o _syaz14q2 _k48p1fw0"
                                                    ]),
                                                    children: text
                                                })
                                        }
                                    }))
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};

});
parcelRegister("6unIx", function(module, exports) {

$parcel$export(module.exports, "ErrorIconImage", function () { return $0089f59eb8842b31$export$a1922be2c234f039; });

var $loA2J = parcelRequire("loA2J");
const $0089f59eb8842b31$var$ErrorIconComponent = ()=>{
    return /*#__PURE__*/ (0, $loA2J.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "105",
        height: "97",
        viewBox: "0 0 105 97",
        fill: "none",
        children: [
            /*#__PURE__*/ (0, $loA2J.jsxs)("g", {
                clipPath: "url(#clip0_2901_19175)",
                children: [
                    /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                        d: "M0.629883 96.2192L0.687156 96.3338H104.306L104.37 96.2192L52.4999 0.357422L0.629883 96.2192Z",
                        fill: "#DDDEE1"
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                        d: "M52.6782 34.6891V69.6954",
                        stroke: "white",
                        strokeWidth: "7.33",
                        strokeMiterlimit: "10"
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                        d: "M55.1283 80.6028C55.1601 80.4373 55.1728 80.2591 55.1728 80.0746C55.1728 79.8901 55.1601 79.7055 55.1283 79.5401C54.9501 78.541 54.2564 77.9301 53.2828 77.771C53.1174 77.7455 52.9455 77.7328 52.761 77.7328C52.5764 77.7328 52.3919 77.7455 52.2201 77.7773C51.2464 77.9364 50.5592 78.5537 50.3746 79.5464C50.3428 79.7119 50.3301 79.8901 50.3301 80.081C50.3301 80.2719 50.3428 80.4437 50.3746 80.6092C50.5528 81.6019 51.2464 82.2128 52.2201 82.3782C52.3919 82.4101 52.5764 82.4228 52.761 82.4228C52.9455 82.4228 53.1174 82.4101 53.2828 82.3846C54.2564 82.2255 54.9501 81.6082 55.1283 80.6155V80.6028Z",
                        stroke: "white",
                        strokeWidth: "7.33",
                        strokeMiterlimit: "10"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("defs", {
                children: /*#__PURE__*/ (0, $loA2J.jsx)("clipPath", {
                    id: "clip0_2901_19175",
                    children: /*#__PURE__*/ (0, $loA2J.jsx)("rect", {
                        width: "105",
                        height: "97",
                        fill: "white"
                    })
                })
            })
        ]
    });
};
const $0089f59eb8842b31$export$a1922be2c234f039 = $0089f59eb8842b31$var$ErrorIconComponent;

});



parcelRegister("f788Q", function(module, exports) {

$parcel$export(module.exports, "init", function () { return $513b3aabfa44d17f$export$2cd8252107eb640b; });

var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $9jv6U = parcelRequire("9jv6U");

var $01JF1 = parcelRequire("01JF1");

var $cGDYS = parcelRequire("cGDYS");

var $7RyUO = parcelRequire("7RyUO");

var $dunoe = parcelRequire("dunoe");

var $k2OeR = parcelRequire("k2OeR");

var $j0nzO = parcelRequire("j0nzO");

var $jpi63 = parcelRequire("jpi63");

var $6wlNh = parcelRequire("6wlNh");

var $9uFWm = parcelRequire("9uFWm");

var $EyEcw = parcelRequire("EyEcw");

var $9Dbz6 = parcelRequire("9Dbz6");
window.BUILD_KEY = "p-ef3aeba81a";
window.featureGateBootstrapValues = window.featureGateBootstrapValues || {
    identifiers: {
        analyticsAnonymousId: (0, $cGDYS.default)()
    }
};
const $513b3aabfa44d17f$var$BASE_URL = "https://www.atlassian.com";
const $513b3aabfa44d17f$var$SUPPORTED_LOCALES = [
    {
        hrefLang: "ja",
        langRoute: "ja"
    },
    {
        hrefLang: "fr",
        langRoute: "fr"
    },
    {
        hrefLang: "de",
        langRoute: "de"
    },
    {
        hrefLang: "es",
        langRoute: "es"
    },
    {
        hrefLang: "pt-BR",
        langRoute: "br"
    },
    {
        hrefLang: "zh-Hans",
        langRoute: "zh"
    },
    {
        hrefLang: "ko",
        langRoute: "ko"
    },
    {
        hrefLang: "ru",
        langRoute: "ru"
    },
    {
        hrefLang: "pl",
        langRoute: "pl"
    },
    {
        hrefLang: "it",
        langRoute: "it"
    },
    {
        hrefLang: "nl",
        langRoute: "nl"
    }
];
const $513b3aabfa44d17f$export$2cd8252107eb640b = (Component)=>{
    const isStatic = typeof window !== "undefined" && window.IS_STATIC;
    const analyticsWebClient = (0, $dunoe.getAnalyticsWebClient)();
    const { locale: locale, path: path } = (0, $9Dbz6.parseRoute)(window.location);
    const route = path !== "" ? "/" + path : "";
    // Get location data for experiments and feature gates from server-provided data
    let locationData;
    // Use server-provided data (no client-side API calls)
    if (typeof window !== "undefined") locationData = {
        countryIsoCode: window.countryCode || "",
        regionIsoCode: window.regionIsoCode || ""
    };
    const isPerfOnetrustEnabled = (0, $k2OeR.isPerformanceOnetrustEnabled)(typeof window !== "undefined" ? window.optanonConsentCookie : (0, $k2OeR.extractOptanonConsentCookie)(document.cookie), locationData);
    isPerfOnetrustEnabled && (0, $7RyUO.initUFO)(analyticsWebClient, path);
    const parsedClientCookies = document.cookie ? (0, $9jv6U.parse)(document.cookie) : {};
    const userAgent = typeof window !== "undefined" ? window.navigator.userAgent : "";
    const { finalExperimentOverrides: finalExperimentOverrides, finalFeatureGateOverrides: finalFeatureGateOverrides } = (0, $EyEcw.processExperimentAndFeatureGateOverrides)(parsedClientCookies, userAgent, isPerfOnetrustEnabled);
    // Below is for debugging edge - will be removed
    window.ssrAnonId = window.featureGateBootstrapValues.identifiers.analyticsAnonymousId;
    // We can't feature gate below code as this is done before initialization so just overriding for the path we are testing
    if ((0, $6wlNh.isEdgeCachingPath)(window.location.pathname)) {
        // Override for Edge Caching
        (0, $6wlNh.overrideAjsAnonIdFromCookie)();
        (0, $6wlNh.overrideCustomAttributes)();
    }
    (0, $j0nzO.initializeFeatureGatesClient)(window.featureGateBootstrapValues, {
        overrideValues: {
            experimentOverrides: finalExperimentOverrides,
            featureGateOverrides: finalFeatureGateOverrides
        },
        // if performance cookies are disabled, we will skip exposures
        localMode: !isPerfOnetrustEnabled
    }).then(()=>{
        const page = /*#__PURE__*/ (0, $loA2J.jsxs)((0, $9uFWm.SentryIntlProvider), {
            locale: locale,
            messages: window.SSR_languagePack,
            cookies: document.cookie,
            children: [
                isStatic && /*#__PURE__*/ (0, $loA2J.jsx)("link", {
                    rel: "canonical",
                    href: `${$513b3aabfa44d17f$var$BASE_URL}${route}`
                }),
                isStatic && /*#__PURE__*/ (0, $loA2J.jsx)("link", {
                    rel: "alternate",
                    href: `${$513b3aabfa44d17f$var$BASE_URL}${route}`,
                    hrefLang: "x-default"
                }),
                isStatic && $513b3aabfa44d17f$var$SUPPORTED_LOCALES.map(({ hrefLang: hrefLang, langRoute: langRoute })=>/*#__PURE__*/ (0, $loA2J.jsx)("link", {
                        rel: "alternate",
                        href: `${$513b3aabfa44d17f$var$BASE_URL}/${langRoute}${route}`,
                        hrefLang: hrefLang
                    }, hrefLang)),
                /*#__PURE__*/ (0, $loA2J.jsx)((0, $jpi63.PageWrapper), {
                    analyticsWebClient: analyticsWebClient,
                    location: window.location,
                    pricing: window.prices,
                    availableProducts: window.availableProducts,
                    userProfile: window.userProfile,
                    userProfileStatus: window.userProfileStatus,
                    userContext: window.userContext,
                    userContextStatus: window.userContextStatus,
                    loggedOutContext: window.loggedOutContext,
                    loggedOutContextStatus: window.loggedOutContextStatus,
                    loggedInContext: window.loggedInContext,
                    loggedInContextStatus: window.loggedInContextStatus,
                    countryCode: window.countryCode,
                    templates: window.templates,
                    partnerTemplates: window.partnerTemplates,
                    collections: window.collections,
                    categories: window.categories,
                    composition: window._uniformPreloadedComposition,
                    isUniformPlayground: window.isUniformPlayground,
                    isAllowPostMessage: window.isAllowPostMessage,
                    teamType: window.teamType,
                    keyword: window.keyword,
                    referrer: window.referrer,
                    mlTemplateIds: window.mlTemplateIds,
                    track: window.track,
                    anchor: window.anchor,
                    subAnchor: window.subAnchor,
                    auxiaResponse: window.auxiaResponse,
                    PageComponent: Component,
                    transactionAccounts: window.transactionAccounts,
                    userAgent: userAgent,
                    clusterTag: window.clusterTag
                })
            ]
        });
        if (isStatic) {
            // @ts-ignore
            const root = (0, $01JF1.createRoot)(document.getElementById("wac"));
            root.render(page);
        } else (0, $01JF1.hydrateRoot)(// @ts-ignore
        document.getElementById("wac-root"), page, {
            onRecoverableError: (error, errorInfo)=>{
                var _document_getElementById;
                (_document_getElementById = document.getElementById("wac-root")) === null || _document_getElementById === void 0 ? void 0 : _document_getElementById.setAttribute("hydration-error", "true");
            }
        });
    });
};

});

parcelRegister("f0Hih", function(module, exports) {

$parcel$export(module.exports, "default", function () { return (parcelRequire("dhmEV")).default; });

var $dhmEV = parcelRequire("dhmEV");

});


var $1KLms = parcelRequire("1KLms");

var $f788Q = parcelRequire("f788Q");
(0, $f788Q.init)((0, $1KLms.SoftwareRovoStartPage));


//# sourceMappingURL=software-rovo-start-page.e2d3fdee.js.map
